import { METADATA_MUX_ATTRS, METADATA_ATTR } from 'src/shared/types/video-metadata-attributes';

export const generateVideoMetadata = ({
  masterClassId,
  percorsoId,
  serieId,
  insegnanteId,
}: {
  masterClassId?: string;
  serieId?: string;
  percorsoId?: string;
  insegnanteId?: string;
}) => ({
  [METADATA_MUX_ATTRS[METADATA_ATTR.SERIE]]: serieId,
  [METADATA_MUX_ATTRS[METADATA_ATTR.MASTERCLASS]]: masterClassId,
  [METADATA_MUX_ATTRS[METADATA_ATTR.PERCORSO]]: percorsoId,
  [METADATA_MUX_ATTRS[METADATA_ATTR.INSEGNANTE]]: insegnanteId,
});
